/*
Import all child theme specific scripts here.
Block interactivity (sliders, accordions, cruise carousels) ships with the
"BANC Blocks" and "Pontoon BANC Addon" plugins, not the theme.
*/

import "./custom/navbar.js"; // Navbar functionality
import "./libs/splide/splide_custom_simple_initialize.js"; // Generic Splide initialiser
import "./custom/load-more-posts.js"; // Load-more posts (AJAX)
import "./custom/popup-modal.js"; // Generic popup/modal handling
